export const DealsBlock = () => <div id="offer-chat-admin" />;
